export { SuggestionsService, SuggestionsMapperService } from './base';
export { suggestionsFactory } from './suggestions-factory.service';
export type { NoMultiLangCompanyCreateRequest } from './suggestion-iterfaces';
